/* global localData */
if (document.querySelector('#join-box')) {
  const joinForm = (() => {
    const r = {
      signUp: document.querySelector('#join-box'),
      button: document.querySelector('#join-box .btn--accept-button'),
      loading: false,
      sendAjax: () => {
        r.isValid = true;
        const formData = {};
        r.signUp.querySelectorAll('input').forEach((input) => {
          const type = input.getAttribute('type');
          switch (type) {
            case 'checkbox':
              formData[input.id] = input.checked;
              if (typeof input.getAttribute('required') === 'string' && !input.checked) {
                input.closest('div').classList.add('is-validation-failed');
                r.isValid = false;
              } else {
                input.closest('div').classList.remove('is-validation-failed');
              }
              break;
            case 'file':
              if (typeof input.getAttribute('required') === 'string' && (!document.querySelector('.upload-box__list  .upload-box__list-text'))) {
                input.closest('.upload-box').classList.add('is-validation-failed');
                r.isValid = false;
              } else {
                input.closest('.upload-box').classList.remove('is-validation-failed');
                document.querySelector('.upload-box__error').style.display = 'none';
              }
              break;
            case 'radio':
              if (document.querySelector('input[name="radio"]:checked')) {
                formData[input.name] = document.querySelector('input[name="radio"]:checked').value;
                input.closest('div').classList.remove('is-validation-failed');
              } else {
                r.isValid = false;
                input.closest('div').classList.add('is-validation-failed');
              }
              break;
            case 'TEXTAREA':
            case 'hidden':
            case 'text':
              formData[input.name] = input.value.trim();
              if (typeof input.getAttribute('required') === 'string' && !formData[input.name]) {
                input.closest('div').classList.add('is-validation-failed');
                r.isValid = false;
              } else {
                input.closest('div').classList.remove('is-validation-failed');
              }
              break;
            default:
          }
        });
        if (r.isValid && !r.loading) {
          r.loading = true;
          const file = document.querySelector('input[type="file"]');
          const ajax = new XMLHttpRequest();
          const formDataInput = new FormData();
          if (file && file.files[0]) {
            formDataInput.append('cvfile', file.files[0]);
          }
          formDataInput.append('inputs', JSON.stringify(formData));
          formDataInput.append('action', 'createSignOnAction');
          formDataInput.append('id', localData.id);
          ajax.open('POST', localData.siteURL, true);
          ajax.onload = function () {
            const response = JSON.parse(ajax.responseText);
            document.querySelector('.upload-box').classList.remove('is-validation-failed');
            if (response.data.status === 200) {
              window.location.href = response.data.url;
            } else if (response.data.status === 406) {
              document.querySelector('.upload-box').classList.add('is-validation-failed');
              document.querySelector('.upload-box__error').style.display = 'block';
            }
            r.loading = false;
          };
          ajax.send(formDataInput);
        }
      },
      initButton: () => {
        r.button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          r.sendAjax();
        });
      },
    };
    return {
      initialize: () => {
        if (r.button) {
          r.initButton();
        }
      },
    };
  })();
  joinForm.initialize();
}
